import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";
import Icon from "../../../../common/components/Icon/Icon";

const OrderActions: React.FC = () => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);
  const timeoutIdRef = useRef<number | null>(null);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }
    };
  }, []);

  const handlePrint = () => {
    window.print();
  };

  const handleCopyUrl = async () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
    }
    try {
      await navigator.clipboard.writeText(window.location.href);
      setIsCopied(true);
      timeoutIdRef.current = window.setTimeout(() => setIsCopied(false), 2500);
    } catch (err) {
      console.error("Failed to copy URL:", err);
      // Show an error toast to the user
      toast.error(t("orderPage.copyUrlError", "Could not copy URL."));
    }
  };

  return (
    <div className="order-page__actions">
      <button
        className={`order-page__action-btn order-page__action-btn--copy ${
          isCopied ? "is-copied" : ""
        }`}
        onClick={handleCopyUrl}
        disabled={isCopied}
      >
        <Icon
          iconName={isCopied ? "check" : "copy"}
          className="icon--stroke-thick"
        />
        <span>
          {isCopied
            ? t("orderPage.copied", "Copied!")
            : t("orderPage.copyUrl", "Copy URL")}
        </span>
      </button>
      <button
        className="order-page__action-btn order-page__action-btn--print"
        onClick={handlePrint}
      >
        <Icon iconName="print" className="icon--stroke-thick" />
        <span>{t("orderPage.print", "Print")}</span>
      </button>
    </div>
  );
};

export default OrderActions;
